import { mapGetters } from 'vuex';

export default {
    data() {
        return {
            sortingValue: 'All'
        }
    },
    computed: {
        ...mapGetters([
            't',
        ]),
        getSortedItemsByLetters() {
            const t = this.t;
            if (this.sortingValue !== 'All') {
                const valueLength = this.sortingValue.length;
                const selectedItems = [];
                for (let i = 0; i < valueLength; i++) {
                    selectedItems.push(...this.getItems.filter((name) => {
                        const firstLetter = t(name, "name").charAt(0);
                        return firstLetter === this.sortingValue.charAt(i);
                    }));
                }
                return selectedItems;
            }
            return this.getItems;
        },
    },
}
